import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { SharedModule } from '../shared/shared.module';
import { LayoutModule } from '../shared/layout/layout.module';
import { AddressBookListComponent } from './address-book-list/address-book-list.component';
import { AddressBookComponent } from './address-book.component';
import { AddressBookRoutingModule } from './address-book-routing.module';
import { AddressBookEffects } from './address-book.effects';
import { AddressBookService } from './address-book.service';
import { addressBookReducer } from './address-book.reducer';
import { MsisdnResolver } from '../shared/msisdn/msisdn.resolver';
import { ContactsModule } from '../contacts/contacts.module';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    LayoutModule,
    TranslateModule,
    NgxPermissionsModule,
    AddressBookRoutingModule,
    StoreModule.forFeature('addressBook', addressBookReducer),
    EffectsModule.forFeature([AddressBookEffects]),
    ContactsModule,
    FormsModule,
    MatTooltipModule
  ],
  declarations: [AddressBookListComponent, AddressBookComponent],
  providers: [AddressBookService, MsisdnResolver]
})
export class AddressBookModule {}
